import { QueryClient } from '@tanstack/react-query';

import { RequestError } from './request-error.js';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // Don't retry client errors (4xx); retry transient failures twice.
          if (error instanceof RequestError && error.status && error.status < 500) return false;
          return failureCount < 2;
        },
      },
    },
  });
}
